import { ExportProps } from '~types/exportProps';

import { formatDateString } from '~libs/dayjs';

import { selectClients } from '~main/selectors/clients/clients';
import { selectStatuses } from '~support-at-home/selectors/supplierInvoices';
import { selectSuppliers } from '~support-at-home/selectors/suppliers';

const fields: ExportProps = {
  reference: {
    type: 'text-like',
    caption: 'Reference',
    checked: true,
    field: 'reference',
    placeholder: 'Filter...',
    columnDef: {
      id: 'reference',
      accessorKey: 'reference',
      header: 'Reference',
    },
  },

  items_reference: {
    type: 'text-like',
    caption: 'SII Reference',
    checked: true,
    field: 'items.reference',
    placeholder: 'Filter...',
    columnDef: {
      id: 'items.reference',
      accessorKey: 'items.reference',
      header: 'SII Reference',
    },
  },

  supplier_id: {
    type: 'multi-lookup',
    field: 'supplier_id',
    caption: 'Supplier',
    placeholder: 'All',
    selectorOptions: selectSuppliers,
    columnDef: {
      id: 'supplier_id',
      accessorFn: (row) => row.supplier?.name ?? '',
      header: 'Supplier',
    },
  },

  due_date: {
    type: 'date-range',
    field: 'due_date',
    caption: 'Due Date',
    checked: false,
    columnDef: {
      id: 'due_date',
      accessorKey: 'due_date',
      header: 'Due Date',
      cell: (info) => formatDateString(info.getValue()),
    },
  },
  created_at: {
    type: 'date-range',
    field: 'created_at',
    caption: 'Created At',
    checked: false,
    columnDef: {
      id: 'created_at',
      accessorKey: 'created_at',
      header: 'Created At',
      cell: (info) => formatDateString(info.getValue()),
    },
  },
  updated_at: {
    type: 'date-range',
    field: 'updated_at',
    caption: 'Updated At',
    checked: false,
    columnDef: {
      id: 'updated_at',
      accessorKey: 'updated_at',
      header: 'Updated At',
      cell: (info) => formatDateString(info.getValue()),
    },
  },

  client_id: {
    type: 'multi-lookup',
    field: 'client_id',
    caption: 'Client',
    placeholder: 'All',
    selectorOptions: selectClients,
  },

  invoice_date: {
    type: 'date-range',
    field: 'invoice_date',
    caption: 'Invoice Date',
    checked: true,
    columnDef: {
      id: 'invoice_date',
      accessorKey: 'invoice_date',
      header: 'Invoice Date',
      cell: (info) => formatDateString(info.getValue()) || '-',
    },
  },

  status: {
    type: 'multi-lookup',
    field: 'status_id',
    columnField: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectStatuses,
    columnDef: {
      id: 'status',
      accessorKey: 'status.name',
      header: 'Status',
    },
  },
};

export default fields;
